import axios from 'axios';

import type { AppStoreInstallResponse, AppStoreInstalledAppsResponse, AppStoreVersionDetailResponse } from './app-store-types';

export type {
  AppStoreInstallResponse,
  AppStoreInstalledApp,
  AppStoreInstalledAppsResponse,
  AppStoreVersionDetailResponse,
} from './app-store-types';

export const getAppVersionDetail = (appStoreAppVersionGuid: string): Promise<AppStoreVersionDetailResponse> => {
  return axios.get(`/app-store/app-version/${appStoreAppVersionGuid}`).then((response) => response.data);
};

export const installApp = (appStoreAppGuid: string, appStoreAppVersionGuid: string): Promise<AppStoreInstallResponse> => {
  return axios.post(`/app-store/app/${appStoreAppGuid}/version/${appStoreAppVersionGuid}/install`).then((response) => response.data);
};

export const getInstalledApps = (): Promise<AppStoreInstalledAppsResponse> => {
  return axios.get('/app-store/installed-app').then((response) => response.data);
};
